module.exports = __webpack_public_path__ + "static/media/card_image_2.19c593e7.png";